import IconChat from "../../../assets/icons/IconChat";

export default function MessagingAnchorButton({ intitialPosition, clickHandler }) {
    return <div className="messagingAnchorButtonContainer">
        <div className="messagingAnchorButton" onClick={(e) => {
            clickHandler(e);
            e.currentTarget.classList.toggle("messagingAnchorButton--open");
        }}>
            <IconChat width={50} className="messagingAnchorButtonIcon"/>
        </div>
    </div>
}
